export enum ChatSwitchTabs {
  PEOPLE = 'people',
  MESSAGES = 'messages',
}
